import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useScModel } from "../scModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportSc } = useScModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.M_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportSc()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}